import React from "react";
import { useNavigate } from "react-router-dom";
import { Wrench, Clock, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import Brand from "../components/Brand";

const NAVY = "#0b1a30";
const ORANGE = "#ff7e00";

export default function MaintenancePage() {
  const navigate = useNavigate();
  const { maintenance, logout } = useAuth();
  const message = maintenance?.message || "Il portale è temporaneamente non disponibile.";
  const eta = maintenance?.eta;

  const doLogout = () => {
    logout();
    navigate("/", { replace: true });
  };

  return (
    <div
      className="min-h-screen relative flex items-center justify-center px-6 py-16 overflow-hidden"
      style={{ backgroundColor: NAVY }}
      data-testid="maintenance-page"
    >
      {/* Decorazioni di sfondo */}
      <div className="pointer-events-none absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full" style={{ background: "radial-gradient(circle, rgba(255,126,0,0.18), transparent 70%)" }} />
      <div className="pointer-events-none absolute -bottom-32 -left-24 w-[520px] h-[520px] rounded-full" style={{ background: "radial-gradient(circle, rgba(22,52,92,0.9), transparent 70%)" }} />

      <div className="relative w-full max-w-[640px] text-center">
        <div className="mb-10 flex justify-center text-[26px]">
          <Brand dark />
        </div>

        <div
          className="mx-auto mb-8 w-20 h-20 rounded-2xl flex items-center justify-center"
          style={{ backgroundColor: "rgba(255,126,0,0.12)", border: "1px solid rgba(255,126,0,0.4)" }}
        >
          <Wrench size={34} style={{ color: ORANGE }} className="animate-pulse" />
        </div>

        <h1 className="text-4xl sm:text-5xl font-black text-white tracking-tight" data-testid="maintenance-title">
          Manutenzione in corso
        </h1>

        <p
          className="mt-6 text-white/70 text-base leading-relaxed max-w-[520px] mx-auto whitespace-pre-line"
          data-testid="maintenance-message"
        >
          {message}
        </p>

        {eta ? (
          <div
            className="mt-8 inline-flex items-center gap-2.5 rounded-full px-5 py-2.5 text-[14px] font-semibold text-white"
            style={{ backgroundColor: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.14)" }}
            data-testid="maintenance-eta"
          >
            <Clock size={16} style={{ color: ORANGE }} />
            <span className="text-white/60 font-normal">Ripristino stimato:</span> {eta}
          </div>
        ) : null}

        <div className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={doLogout}
            data-testid="maintenance-logout-btn"
            className="inline-flex items-center gap-2 text-white/80 hover:text-white text-[13px] font-semibold border border-white/15 hover:border-white/40 px-4 py-2.5 rounded-xl transition-colors"
          >
            <LogOut size={15} /> Esci
          </button>
          <a
            href="/login"
            data-testid="maintenance-admin-link"
            className="text-white/40 hover:text-white/70 text-[12px] font-medium transition-colors"
          >
            Sei un amministratore? Accedi
          </a>
        </div>
      </div>
    </div>
  );
}
